module.exports = __webpack_public_path__ + "bbae98864fc8c63c5ec95b725fd7ba0c.pdf";